console.log('i18n instance loaded', new Date());

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ko from '@/locales/ko.json';
import en from '@/locales/en.json';
import zh from '@/locales/zh.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { ko: { translation: ko }, en: { translation: en }, zh: { translation: zh } },
    lng: 'ko',
    fallbackLng: 'ko',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'], // 사용자가 언어 변경 시 localStorage에 저장하여 재접속 시 유지
    },
    interpolation: { escapeValue: false },
  });

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('i18n hot reloaded');
  });
}

export default i18n;
